import { APP_DEFAULT_API_ENDPOINT } from "../../ENV";

export const
    // DEFAULT_API_ENDPOINT = 'https://forms.techatrium.com/api/v1',
    DEFAULT_API_ENDPOINT = APP_DEFAULT_API_ENDPOINT,
    UPLOAD_FILE_ENDPOINT = DEFAULT_API_ENDPOINT + "/form/upload",
    URL_PARAMETER_RECIPIENT_ORIGIN = 'origin',
    URL_PARAMETER_FORM_UUID = 'uuid',
    URL_PARAMETER_FRAME_KEY = 'fkey',
    URL_PARAMETER_ENDPOINT = 'endpoint',
    URL_PARAMETER_RENDER_MODE = 'mode',
    URL_PARAMETER_SITE_UUID = 'site';


export const RENDER_MODE_ON_SITE = 'on-site',
    RENDER_MODE_IFRAME = 'iframe';

// Variables for app event (subcribe/emitter);
export const EVENT_KEY_ORIGIN = 'event_domain';

// Variables for Iframe message
export const MESSAGE_DATA_OBJECT_KEY = 'tai-form',
    MESSAGE_KEY_EVENT_CODE = 'eventCode',
    MESSAGE_KEY_EVENT_FRAME_KEY = 'frameKey',
    MESSAGE_KEY_INSTANCE_ID = '_id',
    MESSAGE_KEY_ARGUMENT = 'args',
    MESSAGE_KEY_FORM_SIZE = 'formSize',
    MESSAGE_KEY_REDIRECT = 'redirect',
    MESSAGE_KEY_ORIGIN = 'origin',
    MESSAGE_KEY_IMPORT_CSS_URL = 'importCSSUrls',
    MESSAGE_KEY_IMPORT_CSS_INLINE = 'importCSSInline',
    MESSAGE_KEY_DO_RENDER_CAPTCHA = 'renderGcaptcha',
    MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN = 'takeGCaptchaToken',
    MESSAGE_KEY_ON_CAPTCHA_TOKEN = 'captchaToken',
    MESSAGE_KEY_RESPONSE_STATUS = 'messageResponse',
    MESSAGE_KEY_SET_HTML_FONT_SIZE = 'fontSizeHtml',
    MESSAGE_KEY_SCROLL_TO_FRAME = 'scrollToFrame',
    MESSAGE_KEY_SUBMIT_SUCCESS = 'formSubmitted',
    MESSAGE_KEY_SUBMIT_FAILED = 'formFailed',
    MESSAGE_KEY_RETRIEVE_FORM_SOURCE = 'retrieveSource',
    MESSAGE_KEY_FETCH_FORM_DATA = 'fetchForm',
    MESSAGE_KEY_SUBMIT_FORM = 'submitForm',
    MESSAGE_KEY_RENDER_FORM_SOURCE = 'renderSource',
    MESSAGE_KEY_HIDE_FRAME = 'hideFrame',
    MESSAGE_KEY_DO_FORWARD = 'forward',
    MESSAGE_KEY_ON_FORM_READY = 'ready',
    MESSAGE_KEY_ON_FORM_BEFRORE_RENDER = 'beforeFormRendered',
    MESSAGE_KEY_ON_FORM_RENDERED = 'formRendered',
    MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT = 'TCContent',
    MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE = 'validateMessage',
    MESSAGE_KEY_CAN_RENDER_FORM = 'canRender',
    MESSAGE_KEY_SET_FIELD_VALUE = 'setFieldValue',
    MESSAGE_KEY_PAGE_CHANGED = 'pageChanged',
    MESSAGE_KEY_DZ_FILE_UPLOAD = 'dzFileUpload',
    MESSAGE_KEY_ABORT_UPLOAD = 'abortUpload',
    MESSAGE_KEY_CUSTOM_HTML_WIDGET = 'customHTML'

